import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BASE_URL, BaseApi, COMMON_URL } from "@edl-development/edl-common";
import { Observable, map } from 'rxjs';

@Injectable()
export class OnboardingApi extends BaseApi {


  constructor(
    @Inject(BASE_URL) private baseUri: string,
    @Inject(COMMON_URL) private commonUrl: string,
    private http: HttpClient
  ) {
    super();
  }

  getTemplate() {
    return this.http
      .get(this.commonUrl + '/onboarding/template', {
        responseType: 'blob',
      });
  }


  onboardUsers(fileList: FileList) {
    let file: File = fileList[0];
    let formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(this.commonUrl + '/onboarding/onboard', formData);
  }


}
